module.exports = __webpack_public_path__ + "img/danger_ico.a744822.svg";